import Glide from '@glidejs/glide';
import { Autoplay } from '@glidejs/glide/dist/glide.modular.esm';

// Preload all images before initializing carousel
function preloadImages() {
    return new Promise((resolve) => {
        const slides = document.querySelectorAll(".glide .glide__slide img");
        let loadedCount = 0;
        const totalImages = slides.length;

        if (totalImages === 0) {
            resolve();
            return;
        }

        slides.forEach((img) => {
            if (img.complete && img.naturalWidth) {
                loadedCount++;
                if (loadedCount === totalImages) resolve();
            } else {
                const tempImg = new Image();
                tempImg.onload = tempImg.onerror = () => {
                    loadedCount++;
                    if (loadedCount === totalImages) resolve();
                };
                tempImg.src = img.src;
            }
        });
    });
}

function setCarouselHeight() {
    const slides = document.querySelectorAll(".glide .glide__slide");
    let maxTotalHeight = 0;
    let imagesProcessed = 0;
    let imagesLoaded = 0;
    const totalSlides = slides.length;

    console.log(`Found ${totalSlides} slides for height calculation`);

    // Add loading state to prevent flickering
    const glideElement = document.querySelector(".glide");
    glideElement.classList.add('carousel-loading');

    // slides.forEach((slide) => {
    //     const img = slide.querySelector("img");
    //     if (img.complete && img.naturalWidth) {
    //         processSlide(slide, img);
    //     } else {
    //         img.addEventListener("load", () => {
    //             processSlide(slide, img);
    //         });
    //     }
    // });

    slides.forEach((slide) => {
        const img = slide.querySelector("img");
        processSlide(slide, img);
    });

    // function processSlide(slide, img) {
    //     const aspectRatio = img.naturalWidth / img.naturalHeight;
    //     const slideWidth = slide.offsetWidth;
    //     const imgContainerHeight = slideWidth / aspectRatio;
    //     const caption = slide.querySelector(".slide-caption");
    //     const captionHeight = caption ? caption.offsetHeight : 0;
    //     const slideTotalHeight = imgContainerHeight + captionHeight;

    //     maxTotalHeight = Math.max(maxTotalHeight, slideTotalHeight);
        
    //     imagesLoaded++;
    //     if (imagesLoaded === totalSlides) {
    //         applyHeight();
    //     }
    // }

    function processSlide(slide, img) {
        // Ensure image is loaded before calculating
        if (!img.complete || !img.naturalWidth) {
            img.addEventListener("load", () => calculateSlideHeight(slide, img));
        } else {
            calculateSlideHeight(slide, img);
        }
    }

    function calculateSlideHeight(slide, img) {
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        const slideWidth = slide.offsetWidth;
        const imgContainerHeight = slideWidth / aspectRatio;
        const caption = slide.querySelector(".slide-caption, p");
        const captionHeight = caption ? caption.offsetHeight : 0;
        const slideTotalHeight = imgContainerHeight + captionHeight;

        maxTotalHeight = Math.max(maxTotalHeight, slideTotalHeight);
        
        imagesProcessed++;
        if (imagesProcessed === totalSlides) {
            applyHeight();
        }
    }

    // function applyHeight() {
    //     slides.forEach((slide) => {
    //         slide.style.minHeight = `${maxTotalHeight}px`;
    //         const imgContainer = slide.querySelector(".slide-image-container");
    //         if (imgContainer) {
    //             const caption = slide.querySelector(".slide-caption");
    //             imgContainer.style.height = `${maxTotalHeight - (caption?.offsetHeight || 0)}px`;
    //         }
    //     });
    // }

    function applyHeight() {
        // Apply heights synchronously to prevent flickering
        requestAnimationFrame(() => {
            slides.forEach((slide) => {
                slide.style.minHeight = `${maxTotalHeight}px`;
                const imgContainer = slide.querySelector(".slide-image-container");
                if (imgContainer) {
                    const caption = slide.querySelector(".slide-caption, p");
                    const containerHeight = maxTotalHeight - (caption?.offsetHeight || 0);
                    imgContainer.style.height = `${containerHeight}px`;
                    
                    // Ensure image fits container properly
                    const img = imgContainer.querySelector("img");
                    if (img) {
                        img.style.height = '100%';
                        img.style.width = '100%';
                        img.style.objectFit = 'cover';
                        img.style.objectPosition = 'center';
                    }
                }
            });
            
            // Remove loading state
            const glideElement = document.querySelector(".glide");
            glideElement.classList.remove('carousel-loading');
        });
    }
}

// Throttled resize handler for better performance
let resizeTimeout;
function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        setCarouselHeight();
    }, 100);
}

export async function initializeGlide() {
    const glideElement = document.querySelector(".glide");
    if (!glideElement) return;

    // Wait for all images to preload
    await preloadImages();

    const glide = new Glide(".glide", {
        type: "carousel",
        autoplay: 3000,
        hoverpause: true,
        //animationDuration: 1500,
        animationDuration: 1200,
        //animationTimingFunc: 'ease-in-out',
        animationTimingFunc: 'cubic-bezier(0.4, 0, 0.2, 1)', // Better easing for mobile
        perView: 3,
        gap: 10,
        breakpoints: {
            768: {
                perView: 2,
                gap: 5,
                animationDuration: 1000, // Faster on mobile
            },
        },
    });

    //glide.on("mount.after", setCarouselHeight);
    glide.on("mount.after", () => {
        setTimeout(setCarouselHeight, 50); // Small delay to ensure DOM is ready
    });
    // Pause autoplay during transitions to prevent conflicts
    glide.on("run.before", () => {
        glide.disable();
    });

    glide.on("run.after", () => {
        setTimeout(() => {
            glide.enable();
        }, 100);
    });
    //window.addEventListener("resize", setCarouselHeight);
    window.addEventListener("resize", handleResize);
    // Handle orientation change specifically for mobile Safari
    window.addEventListener("orientationchange", () => {
        setTimeout(setCarouselHeight, 200);
    });
    glide.mount({ Autoplay });
}